import { gql } from "@apollo/client";

export const Get_Sms_Templates = gql`
  query SmsTemplatesPagination(
    $skip: Int
    $take: Int
    $where: TemplateFilterInput
    $order: [TemplateSortInput!]
  ) {
    smsTemplates(skip: $skip, take: $take, where: $where, order: $order) {
      items {
        id
        name
        body
        createdOn
        userDisplayName
        workFlowTemplateId
      }
      totalCount
    }
  }
`;

export const Get_WF_SMS_Email_Template_Snapshot = gql`
  query WorkflowSnapshots(
    $skip: Int
    $take: Int
    $where: WorkflowSnapshotFilterInput
    $order: [WorkflowSnapshotSortInput!]
  ) {
    workflowSnapshots(skip: $skip, take: $take, where: $where, order: $order) {
      items {
        id
        workflowId
        actionId
        originalSourceId
        data
        createdOn
        createdBy
      }
    }
  }
`;

export const Get_Sms_Templates_Preview = gql`
  query GerSMSTemplatePreview($id: Int, $templateText: String) {
    previewTemplate(templateId: $id, templateText: $templateText) {
      preview
    }
  }
`;
export const Get_Custom_Codes = gql`
  query GetCustomCode($skip: Int, $take: Int) {
    customCode(skip: $skip, take: $take) {
      items {
        fullName
        columnType
      }
      totalCount
    }
  }
`;
export const Get_Workflow_Association_Sms_Template = gql`
  query Get_Workflow_Association($where: WorkFlowAssociationFilterInput) {
    workFlowAssociations(where: $where) {
      items {
        id
        smsTemplateId
        workFlowName
      }
    }
  }
`;
export const Get_Workflow_Association_Sms_Template_count = gql`
  query Get_Workflow_Association($where: WorkFlowAssociationFilterInput) {
    workFlowAssociations(where: $where) {
      totalCount
    }
  }
`;
